import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';
import { TourCookieValues } from '../../../ui/Tour';
import type AvailabilityCalendar from './AvailabilityCalendar';
import getAvailabilityCalendarSteps from './tour/steps';

export enum SwitchValue {
    AVAILABILITY = 'availability',
    CONFIGURATION = 'configuration'
}

export default class CalendarStateSwitch extends HTMLElement {
    #availabilityCalendar: AvailabilityCalendar | null = null;

    protected async connectedCallback(): Promise<void> {
        this.#availabilityCalendar = document.querySelector('availability-calendar');
        await this.#availabilityConfigurationTour();
        this.#setEventListeners();
    }

    async #availabilityConfigurationTour(): Promise<void> {
        const tourName = 'tour_availability_calendar';
        const tourCookie: string | null = getCookieValue(tourName);
        if (tourCookie === null || tourCookie !== TourCookieValues.completed) {
            const translations = JSON.parse(this.dataset.tourTranslations || '[]');
            const Tour = await this.#initializeTour();
            const tour = new Tour({
                offset: [0, 25],
                name: tourName,
                steps: getAvailabilityCalendarSteps(translations),
                cookie: tourCookie
            });
            tour.startTour();
        }
    }

    #setEventListeners(): void {
        const calendarSwitchInputs: HTMLInputElement[] = Array.from(
            document.querySelectorAll('[name="calendar_switch"]')
        );

        calendarSwitchInputs.forEach((input: HTMLInputElement) => {
            input.addEventListener('change', () => {
                if (!this.#availabilityCalendar) return;
                this.#availabilityCalendar.calendarState = input.value;
            });
        });
    }

    async #initializeTour(): Promise<any> {
        const { default: Tour } = await import(
            /* webpackChunkName: "async-tour" */ '../../../ui/Tour'
        );

        return Tour;
    }
}

if (!customElements.get('calendar-state-switch')) {
    customElements.define('calendar-state-switch', CalendarStateSwitch, { extends: 'header' });
}
